<template>
  <div class="d-flex filter--message">
    <b-dropdown size="lg" class="p-0"  variant="link" toggle-class="text-decoration-none p-0" no-caret >
      <template #button-content>
        <b-icon icon="filter"></b-icon>
      </template>
      <b-dropdown-item v-for="(item, index) in arrayItems" :key="index"  @click="updateFilterMessage(item.value)">
        <p class="text--dropdown--item">
          <b-icon :style="{color: '#044389'}" :icon="item.value === filterMessage ? 'circle-fill' : 'circle'"/>
          {{item.text}}
        </p>
      </b-dropdown-item>
    </b-dropdown>
    <b-badge variant="outline-primary" class="badge--dropdown--select"><b-icon icon="circle-fill" aria-hidden="true" scale="1"></b-icon> {{ textValue }}</b-badge>
  </div>
</template>
<script>
import {
  BIcon,
  BIconFilter,
  BIconCircleFill,
  BIconCircle
} from 'bootstrap-vue'
/* eslint-disable vue/no-unused-components */
export default {
  props: ['filterDefault'],
  components: {BIcon, BIconFilter, BIconCircleFill, BIconCircle},
  data() {
    return {
      filterMessage: '',
      arrayItems: [
        {
          value: 'all',
          text: 'Todo'
        },
        {
          value: 'left',
          text: 'Hilo de mensajes'
        },
        {
          value: 'center',
          text: 'Tracking'
        }
      ]
    }
  },
  watch: {
    filterDefault(value) {
      this.filterMessage = value
    }
  },
  computed: {
    textValue() {
      return this.arrayItems.find(el => el.value === this.filterMessage)?.text || ''
    }
  },
  mounted() {
    this.filterMessage = this.filterDefault || 'all'
  },
  methods: {
    updateFilterMessage(value) {
      this.$emit('filterMessage', value)
    }
  }
}
</script>
<style lang="scss">
  .filter--message {
    .text--dropdown--item {
      margin: 0;
      font-family: Montserrat;
      font-size: 12px;
      font-weight: 400;
      line-height: 14.63px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      color: #5C5C5C;
    }
    .badge--dropdown--select {
      font-family: Montserrat;
      font-size: 10px;
      font-weight: 400;
      line-height: 12.19px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }
  }
</style>